import React from 'react';

var MobileGameMainCont = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'mobile-wr' }, children);
};

export { MobileGameMainCont };
